import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=dad8b0d2&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dad8b0d2')) {
      api.createRecord('dad8b0d2', component.options)
    } else {
      api.reload('dad8b0d2', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=dad8b0d2&", function () {
      api.rerender('dad8b0d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2J6W0v6xZznwA/JS/cancellationPolicy.vue"
export default component.exports